export default "__VITE_ASSET__D5JFv_Hl__"